module.exports = __webpack_public_path__ + "static/media/logo.850c838a.svg";